import { motion } from 'framer-motion';

export const PageHeader = ({ eyebrow, title, italicTail, lede, children }) => (
  <section className="pt-32 md:pt-40 pb-14 md:pb-20 border-b border-border">
    <div className="mx-auto container-editorial">
      <div className="flex items-center justify-between mb-8">
        <span className="label-eyebrow">{eyebrow}</span>
        <span className="label-eyebrow hidden md:inline !text-sienna">TechsFlow · Studio Notes</span>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-end">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.7, 0, 0.2, 1] }}
          className="lg:col-span-8 display-hero text-5xl md:text-7xl lg:text-8xl text-balance"
        >
          {title}
          {italicTail && <span className="italic-serif text-sienna"> {italicTail}</span>}
        </motion.h1>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.7 }}
          className="lg:col-span-4"
        >
          {lede && <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-md">{lede}</p>}
          {children}
        </motion.div>
      </div>
    </div>
  </section>
);

export default PageHeader;
